import React, { memo } from 'react'
import { oneOfType, number, string } from 'prop-types'
import { useTheme } from 'emotion-theming'

export const Arrow = memo(({ height = '100%', color, variant = 'white', width = '100%' }) => {
	const { colors } = useTheme()
	const fillColor = color || colors[variant]

	return (
		<svg
			height={height}
			width={width}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 34.2 43.2"
			style={{ enableBackground: 'new 0 0 34.2 43.2' }}
			xmlSpace="preserve"
		>
			<g>
				<polyline
					fill="none"
					stroke={fillColor}
					strokeWidth={4}
					strokeLinecap="round"
					strokeMiterlimit={10}
					points="2,25.5 17.1,40.4 32.2,25.5"
				/>
				<line
					fill="none"
					stroke={fillColor}
					strokeWidth={4}
					strokeLinecap="round"
					strokeMiterlimit={10}
					x1="17.1"
					y1="38.5"
					x2="17.1"
					y2="2"
				/>
			</g>
		</svg>
	)
})

Arrow.propTypes = {
	color: string,
	height: oneOfType([number, string]),
	width: oneOfType([number, string]),
}
